const styles = {
    //GENERAL
    container: {
        textAlign: 'center',
        width: '90%',
        margin: 'auto',
    },
    titleContainer: {
        fontSize: '25px',
        fontWeight: 'bolder',
        textAlign: 'left',
        marginTop: '30px',
        color: '#fff',
        position: 'relative'
    },
    meetingsFilter: {
        display: 'inline-block',
        position: 'absolute',
        right: 0,
        top: 0,
    },
    meetingsFilterSelector: {
        verticalAlign: 'middle',
    },
    gridList: {
        width: '100%',
        overflowY: 'auto',
        margin: 0,
    },
    editIconStyle: {
        position: 'absolute',
        display: 'inline-block',
        right: '5px',
        bottom: '5px'
    },
    //MEETINGS
    meetingsGridList: {
        width: 'calc(100% - 260px)',
        display: 'inline-block',
        verticalAlign: 'top'
    },
    meetingsGridListSmartphone: {
        width: '100%',
        display: 'inline-block',
        verticalAlign: 'top'
    },
    //PRIMARYMEETING

    featuredMeetingContainer: {
        backgroundColor: '#fff',
        display: 'inline-block',
        height: '260px',
        width: '250px',
        position: 'relative',
        verticalAlign: 'top',
        marginRight: '10px',
        cursor: 'pointer',
        textAlign: 'center',
        marginTop: '5px',
    },
    noContentPlaceholder: {
        color: '#fff',
        textAlign: 'center',
        height: '260px',
        width: '100%',
    },
    featuredMeetingItemDateDay: {
        marginTop: '20px',
        fontSize: '75px',
        fontWeight: 'bolder',
        color: 'rgb(242,0,0)',
        lineHeight: '85px',
    },
    featuredMeetingItemDateMonth: {
        textTransform: 'capitalize',
        fontWeight: 'bolder',
        fontSize: '25px',
    },
    featuredMeetingItemTime: {
        fontSize: '15px',
        fontWeight: 'bold',
        marginTop: '15px'
    },
    featuredMeetingItemTitle: {
        fontSize: '12px',
        color: '#fff',
        padding: '10px',
        textAlign: 'left',
        position: 'absolute',
        height: '30px',
        paddingRight: '45px',
        bottom: 0,
        left: 0,
        right: 0,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    //SECONDARY MEETING
    meetingsItemImageContainer: {
        cursor: 'pointer',
        textAlign: 'center',
    },
    meetingItemDateMonth: {
        display: 'inline-block',
        float: 'left',
        margin: '5px 10px',
    },
    bigText: {
        fontSize: '35px',
        lineHeight: '40px',
        fontWeight: 'bolder',
    },
    dateMonth: {
        fontSize: '20px',
        textTransform: 'capitalize',
        fontWeight: 'bolder',
    },
    meetingItemTime: {
        display: 'inline-block',
        fontSize: '15px',
        fontWeight: 'bold',
        float: 'right',
        textAlign: 'right',
        margin: '10px',
    },
    itemTitleContainer: {
        fontSize: '12px',
        color: '#000',
        padding: '10px',
        textAlign: 'left',
        position: 'absolute',
        height: '30px',
        paddingRight: '45px',
        bottom: 0,
        left: 0,
        right: 0,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        backgroundColor: '#cacaca'
    },

    //COLLECTIONS
    collectionsItemImage: {
        width: 'calc(100%)',
        height: 'calc(150px - 40px)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    },
    collectionItemTitleContainer: {
        width: '100%',
        height: 'calc(40px)',
        color: '#000',
        backgroundColor: '#fff',
        textAlign: 'left',
        position: 'relative',
    },
    collectionItemName: {
        position: 'absolute',
        top: '50%',
        left: '15px',
        right: '35px',
        transform: 'translate(0,-50%)',
        fontSize: '12px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    modalContent: {
        overlay: {
            zIndex: 4000
        },
        content: {
            zIndex: 4001,
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        }
    },
    paper: {
        overflowY: 'visible',
    }
};

export default styles;